/**
 * Paths relative to the axios client `baseURL` (`${API_URL}/api`).
 *
 * Keep aligned with the Nest app: `setGlobalPrefix("api")`, then controller paths
 * (`auth`, `users`, `projects`, `match-properties`, `feature-flags`, `requests`, `health`, `v1` for evaluate).
 * OAuth browser redirect: `${API_URL}/api/auth/google` (callback `/api/auth/google/callback`).
 */
export const apiPaths = {
  auth: {
    /** Segment after `/api` (`GET /api/auth/google`). */
    google: "/auth/google",
    logout: "/auth/logout",
  },
  users: {
    me: "/users/me",
  },
  projects: {
    list: "/projects",
    one: (id: string) => `/projects/${id}`,
    apiKeys: (projectId: string) => `/projects/${projectId}/api-keys`,
    apiKey: (projectId: string, keyId: string) =>
      `/projects/${projectId}/api-keys/${keyId}`,
  },
  matchProperties: {
    list: "/match-properties",
    one: (id: string) => `/match-properties/${id}`,
  },
  featureFlags: {
    list: "/feature-flags",
    one: (id: string) => `/feature-flags/${id}`,
    toggle: (id: string) => `/feature-flags/${id}/toggle`,
    rules: (flagId: string) => `/feature-flags/${flagId}/rules`,
    rule: (flagId: string, ruleId: string) =>
      `/feature-flags/${flagId}/rules/${ruleId}`,
  },
  requests: {
    list: "/requests",
    /** Backend registers this before `GET /requests` so `stats` is not ambiguous. */
    stats: "/requests/stats",
  },
} as const;
